export default __webpack_public_path__ + "static/media/Hero Pic.042360ac.png";